export default __webpack_public_path__ + "static/media/Gujarat_3.4acc639a.png";